import { render } from "./NewPagePost.vue?vue&type=template&id=5efa3b30"
import script from "./NewPagePost.vue?vue&type=script&lang=js"
export * from "./NewPagePost.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/mkssg/mkssg/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__